import React, { useContext } from "react";
import RdContext from "../../contexts/RdProvider";
import { RdContextType } from "../../@types/Rd";
import { InteractionType } from "@azure/msal-browser";
import { Button } from "react-bootstrap";


/**
 * Renders a sign-out button
 */
export const SignOutButton = () => {
    const { Logout } = useContext(RdContext) as RdContextType;

    return (
        <Button
            className="ml-auto"
            variant="secondary"
            title="Sair"
            children="Sair"
            onClick={() => Logout(InteractionType.Redirect)}
        />
    )
}